import { useEffect, useState, useRef } from "react";

export const useTimer = (hasToLogout: boolean, seconds: number) => {
  const [isActiveTimer, setIsActiveTimer] = useState(false);
  const [countDown, setCountDown] = useState(seconds);
  const timeLeft = useRef<number>(0);

  useEffect(() => {
    if (seconds > 0 && hasToLogout) {
      setCountDown(seconds);
      setIsActiveTimer(true);
      timeLeft.current = new Date().getTime() + seconds * 1000;
    }

    return () => {
      timeLeft.current = 0;
      setCountDown(0);
    };
  }, [seconds, hasToLogout]);

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;

    if (isActiveTimer) {
      timerId = setInterval(() => {
        const currentDate = new Date().getTime();
        const delta = timeLeft.current - currentDate;

        if (delta > 0) {
          setCountDown(Math.round(delta / 1000));
        } else {
          setIsActiveTimer(false);
          setCountDown(0);
          timeLeft.current = 0;
        }
      }, 1000);
    }

    return () => clearInterval(timerId);
  }, [isActiveTimer, countDown]);

  return { countDown };
};
